module.exports = __webpack_public_path__ + "static/img/yxxt@2x.9ed5ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/yxxt@2x.png
// module id = JWV7
// module chunks = 1